// TODO MOVE TO OTHER FILE

export interface ApiResponse<T> {
    data?: T | null;
    code?: number | null;
    message?: string | null;
}

export interface ApiErrorResponse {
    code?: number | null;
    message?: string | null;
    exception?: ExceptionType | null;
}

export interface ExceptionType {
    message?: string | null;
    errors?: Record<string, string[]> | null;
}

// TODO MOVE TO Drawer types
export enum DrawerId {
    ParentField = "parentField",
    FieldSettings = "fieldSettings",
    AddOffer = "addOffer",
    AddAffiliate = "addAffiliate",
    AddAdvertiser = "addAdvertiser",
    AddTrackingToolFrom = "AddTrackingToolFrom",
    AddTrackingToolTo = "AddTrackingToolTo",
    FormStructure = "formStructure",
    EditOfferGeneral = "editOfferGeneral",
    AddLabel = "addLabel",
    EditLabel = "editLabel",
    AddOfferGeneral = "addOfferGeneral",
    OfferCommissionsOverview = "offerCommissionsOverview",
    AddCommissionGroup = "addCommissionGroup",
    EditCommissionGroup = "editCommissionGroup",
    DetailCommission = "detailCommission",
    AddCommission = "addCommission",
    EditCommission = "editCommission",
    FormDesignAdd = "formDesignAdd",
    FormDesignPreviewAdd = "formDesignPreviewAdd",
    FormDesignPreviewEdit = "formDesignPreviewEdit",
    TransactionReportDetail = "transactionReportDetail",
    TransactionReportEdit = "transactionReportEdit",
    AffiliateRequestPayoutDetail = "affiliateRequestPayoutDetail",
    AffiliateRequestPayoutEdit = "affiliateRequestPayoutEdit",
    AffiliateRequestPayoutCard = "affiliateRequestPayoutCard",
    AffiliateOfferDetail = "affiliateOfferDetail",
    AffiliateEntryDetail = "affiliateEntryDetail",
    LogClickDetail = "logClickDetail",
    LogLeadDetail = "logLeadDetail",
    LogConversionDetail = "logConversionDetail",
    TableFilter = "tableFilter",
    TableColumnsVisibility = "tableColumnsVisibility",
    AddFinanceCost = "addFinanceCost",
    DetailFinanceCost = "detailFinanceCost",
    AffiliateDetail = "affiliateDetail",

    AdvertiserDetail = "advertiserDetail",
    AddApiIntegration = "addapiIntegration",
    ModifyIntegrationMethods = "modifyIntegrationMethods",
    ModifyPostbackIncomingMethods = "modifyPostbackIncomingMethods",
    ModifyPostbackOutgoingMethods = "modifyPostbackOutgoingMethods",

    ModifyIntegration = "modifyIntegration",
    ModifyIncomingPostback = "modifyIncomingPostback",
    ModifyOutgoingPostback = "modifyOutgoingPostback",

    MethodStepSetting = "methodStepSetting",
    MethodPropertyBodySetting = "methodPropertyBodySetting",
    MethodPropertyUrlSetting = "methodPropertyUrlSetting",
    MethodPropertyHeaderSetting = "methodPropertyHeaderSetting",
    ResponseHowToUseSetting = "responseHowToUseSetting",
    ResponseFurtherStepSetting = "responseFurtherStepSetting",
    ResponseConditionsSetting = "responseConditionsSetting",
    ConnectionSequenceStepLog = "connectionSequenceStepLog",
    AddApiToolCustomField = "addApiToolCustomField",
    CascadeCommissions = "cascadeCommissions",
    IntegrationTest = "integrationTest",
    OutgoingPostbackTest = "outgoingPostbackTest",
    IncomingPostbackTest = "incomingPostbackTest",
    ManageCustomDomain = "manageCustomDomain",
    ManageConversionPixel = "manageConversionPixel",
    DashboardCardsVisibility = "dashboardCardsVisibility",
    AddCustomInformationField = "addCustomInformationField",
    AddCustomRuleField = "addCustomRuleField",
    OfferApiDocumentation = "offerApiDocumentation",
    AddFormStructureScenario = "addFormStructureScenario",
    Breaker = "breaker",
    CascadeLogDetail = "cascadeLogDetail",
    IncomingPostbackLogDetail = "incomingPostbackLogDetail",
    OutgoingPostbackLogDetail = "outgoingPostbackLogDetail",
    IntegrationStepLogDetail = "integrationStepLogDetail",
    IncomingPostbackStepLogDetail = "incomingPostbackStepLogDetail",
    OutgoingPostbackStepLogDetail = "outgoingPostbackStepLogDetail",
    StructureStepLogDetail = "structureStepLogDetail",
    InvitePartner = "invitePartner",
    PartnerDetail = "partnerDetail",
    RequestProgramAccess = "requestProgramAccess",
    ProgramDetail = "programDetail",
    AddCascade = "addCascade",
    CascadeDetail = "cascadeDetail",
    CascadeFilter = "cascadeFilter",
}

// TODO MOVE TO OTHER FILE
export enum TableId {
    TestUsersTable = "t1",
    FormStructureTable = "t2",
    CommissionGroupsTable = "t3",
    CommissionsTable = "t4",
    OfferTable = "t5",
    OfferGeneralGeneralInformation = "t6",
    FormDesignTable = "t7",
    TransactionReportTable = "t8",
    AffiliateRequestPayoutTable = "t9",
    InvoicesOverviewTable = "t12",
    RequestsOverviewTable = "t13",
    AffiliateReportTable = "t14",
    AffiliateOfferTable = "t15",
    AffiliateEntryTable = "t16",
    OffersReportTable = "t17",
    AffiliateReportDetailTable = "t18",
    PerformanceReportTable = "t19",
    AdvertiserReportTable = "t20",
    OfferTenantCommissionsTable = "t21",
    OfferUsersCommissionsTable = "t22",
    OfferCommissionsOverviewTable = "t23",
    FinanceCostsTable = "t24",
    FinanceBonusesTable = "t25",
    FinancePenaltiesTable = "t26",
    FinanceRevenuesTable = "t27",
    AffiliatesTable = "t28",
    ApiIntegrationsTable = "t29",
    ConversionLogsTable = "t31",
    IntegrationStepLogsTable = "t32",
    TrackingToolsFrom = "t33",
    TrackingToolsTo = "t34",
    PingTreeReportTable = "t35",
    PingTreeReportDetailTable = "t36",
    AccountTenantsTable = "t37",
    AdvertisersTable = "t38",
    ApiToolCustomFieldsTable = "t39",
    TrackingOutLogsTable = "t41",
    DashboardPerformanceReportTable = "t42",
    ConversionClickLogsTable = "t43",
    ConversionLeadLogsTable = "t44",
    ConversionsTable = "t45",
    StructureLogsTable = "t46",
    CascadeCommissionsTable = "t47",
    LabelsTable = "t47",
    CustomDomainsTable = "t48",
    OfferInformationTable = "t49",
    OfferRuleTable = "t50",
    CommissionsTableExpanded = "t51",
    ScenarioFormStructureTable = "t52",
    CascadeLogTable = "t53",
    IncomingPostbackLogTable = "t54",
    OutgoingPostbackLogTable = "t55",
    IntegrationStepLogTable = "t56",
    IncomingPostbackStepLogTable = "t57",
    OutgoingPostbackStepLogTable = "t58",
    StructureStepLogTable = "t59",
    ActiveProgramsTable = "t60",
    ProgramsCatalogTable = "t61",
    PartnersCatalogTable = "t62",
    PingtreeCascadesTable = "t63",
}

export enum FormId {
    FormFieldsForm = "formFieldsForm",
    FormStructureForm = "formStructureForm",
    FormStructureEditor = "formStructureEditor",
    FormDesignGeneralForm = "formDesignGeneralForm",
    AddOffer = "addOffer",
    AddApiForm = "addApiForm",
    AddLabel = "addLabel",
    EditLabel = "editLabel",
    AddApiToolCustomField = "addApiToolCustomField",
    OfferGeneralEditForm = "offerGeneralEditForm",
    OfferLinkEditForm = "offerLinkEditForm",
    OfferLinkDetailForm = "offerLinkDetailForm",
    OfferFilterEditForm = "offerFilterEditForm",
    OfferFormDetailForm = "offerFormDetailForm",
    OfferApiDetailForm = "offerApiDetailForm",
    OfferApiFormEditForm = "offerApiFormEditForm",
    ApiToolGeneralForm = "apiToolGeneralForm",
    ApiToolEditorForm = "apiToolEditorForm",
    TrackingToolFromGeneralForm = "trackingToolFromGeneralForm",
    TrackingToolFromEditorForm = "trackingToolFromEditorForm",
    TrackingToolToGeneralForm = "trackingToolToGeneralForm",
    TrackingToolToEditorForm = "trackingToolToEditorForm",
    TrackingToolToExportForm = "trackingToolToExport",
    TrackingToolFromExportForm = "trackingToolFromExport",
    TrackingToolFromMethodsExportForm = "trackingToolFromMethodsExport",
    CascadeForm = "cascadeForm",
    AccountPasswordForm = "accountPasswordForm",
    AddUserForm = "addUserForm",
    TenantSettingsForm = "tenantSettingsForm",
    AddCommissionGroup = "addCommissionGroup",
    ManageCommissionForm = "manageCommissionForm",
    DetailCommissionForm = "detailCommissionForm",
    CommissionGroupEditForm = "commissionGroupEditForm",
    AddTrackingToolToForm = "addTrackingToolToForm",
    AddTrackingToolFromForm = "addTrackingToolFromForm",
    AffiliateRequestPayoutCardForm = "affiliateRequestPayoutCardForm",
    ConversionPayoutGroupForm = "conversionPayoutGroupForm",
    IntegrationTestForm = "integrationTestForm",
    OutgoingPostbackTestForm = "outgoingPostbackTestForm",
    IncomingPostbackTestForm = "incomingPostbackTestForm",
    ManageCustomDomainForm = "manageCustomDomainForm",
    AddCustomInformationFieldForm = "addCustomInformationFieldForm",
    AddCustomRuleFieldForm = "addCustomRuleFieldForm",
    TransactionReportEditForm = "transactionReportEditForm",
    ScenarioGeneralForm = "scenarioGeneralForm",
    AddFormStructureScenarioForm = "addFormStructureScenarioForm",
    AccountProfileForm = "accountProfileForm",
    CreateTenantForm = "createTenantForm",
    RequestProgramAccessForm = "requestProgramAccessForm",
    AddCascadeForm = "addCascadeForm",
    CascadeFilterForm = "cascadeFilterForm",
}

export enum FormType {
    Create = "create",
    Edit = "edit",
    Detail = "detail",
}

export interface Identifiable {
    id?: string | number | null;
}

export interface NonIdentifiable {}

export type Nullable<T> = {
    [K in keyof T]: T[K] | null;
};

export enum DefaultStatus {
    Success = "success",
    Error = "error",
    Warning = "warning",
}
